import SharePage from './pages/Page.vue';

export { SharePage };